import { Mail } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminEmailCampaigns() {
  return (
    <CollectionAdmin
      path="email-campaigns"
      title="Email kampanje"
      subtitle="Ciljane marketinške email poruke"
      icon={Mail}
      testid="admin-email-campaigns"
      fields={[
        { key: 'name', label: 'Naziv kampanje' },
        { key: 'subject', label: 'Naslov emaila' },
        { key: 'body', label: 'Tekst (HTML)', type: 'textarea' },
        { key: 'segment', label: 'Segment (all/active/inactive/...)' },
        { key: 'scheduled_at', label: 'Zakazano (ISO)' },
        { key: 'status', label: 'Status (draft/scheduled/sent)' },
      ]}
    />
  );
}
